import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
/**
 * MC GPO-131 Servicio para cargar los recursos de la API
 */
export class RecursosService {
  public resource: any = {};

  constructor() { }

  cargarRecursos() {
    return fetch('./assets/config/resource.json')
    .then(response => response.json())
    .then((r)=>{
      this.resource = r;
    })
  }
}
